<template>
    <div>
      <div class="flex items-center justify-end w-full">

        <v-button
          @click="openCustomfieldModal(null)"
          icon="plus"
        >{{ $t('add_customfield') }}</v-button>
        <!-- Modal -->
        <customfield-add-modal
          ref="custom_field_modal"
          @reload-custom-fields="() => reload()"
        />
      </div>
    


  <div class="flex mt-5">
    <!-- Columna Izquierda - custom fields -->
    <div :class="[( customFieldId || checkedRows.length > 0 ? 'w-8/12' : 'w-full'), 'mr-2']">
      <!-- Tabla de custom Fields -->
      <div class="panel">
        <div v-if="isLoading" class="my-4 text-center">
          <scale-loader></scale-loader>
        </div>
        <div v-else>
          <div class="flex flex-wrap w-full mt-4">
          <section class="w-full">
            <b-table
              icon-pack="fas"
              :data="customfields"
              :paginated="isPaginated"
              :per-page="perPage"
              :bordered="true"
              :current-page.sync="currentPage"
              :pagination-simple="isPaginationSimple"
              :default-sort-direction="defaultSortDirection"
              v-if="!isLoading"
              
              checkbox-position="left"
              :checkbox-type="'is-success'"
              :checked-rows.sync="checkedRows">
              <template>
                <b-table-column field="code" sortable>
                  <template v-slot:header="">{{ $t('code') }}</template>
                  <template v-slot="props">{{ props.row.code }}</template>
                </b-table-column>

                <b-table-column field="name" sortable>
                  <template v-slot:header="">{{ $t('name') }}</template>
                  <template v-slot="props">{{ props.row.name }}</template>
                </b-table-column>

                <b-table-column field="type" sortable>
                  <template v-slot:header="">{{ $t('type') }}</template>
                  <template v-slot="props">{{ fieldTypes[props.row.field_type] }}</template>
                </b-table-column>

                <b-table-column field="order" sortable>
                  <template v-slot:header="">{{ $t('order') }}</template>
                  <template v-slot="props">{{ props.row.order_column }}</template>
                </b-table-column>

                <b-table-column field="actions" width=100 sortable>
                  <template v-slot:header="">{{ $t('actions') }}</template>
                  <template v-slot="props">
                    <div class="flex items-center justify-around w-full h-full">
                      <b-tooltip :label="$t('edit')" position="is-left">
                          <div @click="openCustomfieldModal(props.row)"
                              class="flex cursor-pointer text-blue">
                            <b-icon pack="fas" icon="pencil-alt"/>
                          </div>
                      </b-tooltip>
                      <b-tooltip :label="$t('delete')" position="is-left" type="is-danger">
                          <div @click="removeCustomfield(props.row)"
                              class="flex cursor-pointer text-red">
                            <b-icon pack="fas" icon="trash-alt"/>
                          </div>
                      </b-tooltip>
                      <b-tooltip :label="$t('view_values')" position="is-left">
                          <div @click="onRowClicked(props.row)"
                              class="flex cursor-pointer text-sky-300">
                            <b-icon pack="fas" icon="eye"/>
                          </div>
                      </b-tooltip>

                    </div>
                  </template>
                </b-table-column>
              </template>

              <template slot="bottom-left">
                  <b-icon pack="fas" class="flex text-blue" icon="folder"></b-icon>
                  <b>{{ $t("total") }}</b>: {{ this.customfields.length }}
              </template>

              <template #empty>
                  <div class="has-text-centered">{{ $t('no_results') }}</div>
              </template>

            </b-table>
          </section>
          </div>
        </div>
      </div>
    </div>

    <!-- Columna derecha - Values -->
    <div v-if="showPanelValues" class="w-4/12 ml-2">
      <!-- Elements Attribute Value -->
      <div class="panel">

        <div v-if="loaded" class="my-4 text-center">
          <scale-loader></scale-loader>
        </div>

        <div v-if="customFieldId && !loaded">
          <div class="flex items-center justify-between w-full mb-5">
            <div><label><b>{{ $t('values') }} <span v-if="customFieldId && form.name"> - {{ $t('customfield') + ' ' + form.name }}</span></b></label></div>
            <div>
              <b-tooltip :label="$t('close')" position="is-left">
                <div class="flex items-center justify-center w-8 h-8 rounded-full cursor-pointer bg-red text-grey-lightest" @click="onCloseClicked">
                  <b-icon pack="fas" icon="times" size="is-small" />
                </div>
              </b-tooltip>
            </div>
          </div>

          <!-- recuadro de valores -->
          <div class="w-full border border-blue-lighter rounded flex-col items-center p-2 bg-blue-lightest mb-1"
            v-for="(value, taskKey) in form.values" :key="value.id">

            <div class="flex items-center">
              <!-- delete -->
              <b-tooltip :label="$t('remove')" position="is-left" type="is-danger">
                  <div @click="deleteValue(value.id, value.name)" class="flex cursor-pointer text-red">
                    <b-icon pack="fas" icon="trash-alt"/>
                  </div>
              </b-tooltip>
              <!-- save -->
              <b-tooltip v-if="valuesInEdition.includes(value.id)" :label="$t('save')" position="is-left">
                  <div @click="sendValueData(value.id, taskKey)" class="flex cursor-pointer text-blue">
                    <b-icon pack="fas" icon="download"/>
                  </div>
              </b-tooltip>
              <!-- edit -->
              <b-tooltip v-else :label="$t('edit')" position="is-left">
                  <div @click="editValue(value.id)" class="flex cursor-pointer text-blue">
                    <b-icon pack="fas" icon="pencil-alt"/>
                  </div>
              </b-tooltip>

              <span v-if="valuesInEdition.includes(value.id)" class="inline-flex ml-2">
                <input v-model="form.values[taskKey].code" type="text" class="mr-2 input">
                <input v-model="form.values[taskKey].name" type="text" class="mr-2 input">
              </span>
              <span v-else class="ml-2">
                <span v-if="value.code">{{ value.code }} - </span>
                {{ value.name }}
              </span>
            </div>
          </div>
          <div v-if="form.values.length == 0" class="w-full border border-blue-lighter rounded flex-col items-center p-2 bg-gray-200 mb-1 has-text-centered">{{ $t('no_results') }}</div>
          <!-- recuadro añadir values -->
          <div class="w-full border border-blue-lighter rounded flex items-center p-2 bg-blue-lightest mb-1" v-if="form.field_type == 0">

            <b-tooltip :label="$t('add_generic')" position="is-left">
                <button class="btn btn-green items-center mr-2"  type="button" @click="saveValue()">
                  <i class="fas fa-plus"></i>
                </button>
            </b-tooltip>

            <!-- <b-tooltip :label="$t('name')" position="is-left"> -->
              <span class="inline-flex ml-2">
                <input v-model="newValue.code" type="text" :placeholder="$t('code')" class="input mr-2">
                <input v-model="newValue.name" type="text" :placeholder="$t('name')" class="input mr-2">
              </span>
            <!-- </b-tooltip> -->
          </div>
        </div>

      </div>
    </div>
  </div>

  </div>

</template>

<script>
import Form from "vform";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import Multiselect from 'vue-multiselect'

import { mapGetters } from "vuex";

// import MeasurementUnitModal from "./measurement-unit-modal";
import axios from "axios";

import CustomfieldAddModal from "./customfield-add-modal.vue";

export default {
  name: "company-customfields-manual",

  components: {
    // MeasurementUnitModal,
    ScaleLoader,
    CustomfieldAddModal,
    Multiselect,
  },

  props: {
    projectId: { type: Number, required: true },
    // isAdminMeasurements: { type: Boolean, default: false }
  },

  data: () => ({
    isLoading: true,
    page: 1,
    perPage: 25,
    total: 0,
    orderField: "reference_code",
    orderDir: "asc",
    currentPage: 1,
    isPaginationSimple: false,
    defaultSortDirection: 'asc',
    isPaginated: true,

    customfields: [],
    checkedRows: [],

    activities: [],
    activity: {},

    // values
    customFieldId: null,
    form: new Form({
      code: '',
      name: '',
      values: [],
    }),

    newValue: new Form({
      code: '',
      name: '',
    }),

    valuesInEdition: [], // valor que estan en modo edicion. Editor inline
    disableSaveButton: false,
    loaded: false,
    loadingAssigned: false,
    processingData: false,

    fieldTypes: [
      'select',
      'input',
      'calendar',
      'checkbox',
    ],

    showPanel: 'none',
    statuses: [],
    statusesSelected: [],
    disabled: false,
    linkActiveTab: 0,
  }),

  mounted() {
    this.getCustomfields();
  },

  computed: {
    showPanelValues: function() {
      return this.customFieldId && this.showPanel === 'values' && this.checkedRows.length == 0;
    },
    ...mapGetters({
      company: "app/company",
    })
  },

  methods: {
    async getCustomfields() {
      this.isLoading = true;
      let params = {
        company_id: this.company.id,
        order_dir: this.orderDir,
        order_field: this.orderField
      };

      const { data } = await axios.get(
        "/api/v2/company/" + this.company.id + "/customfields",
        { params: params }
      );

      if (data && data.success) {
        this.customfields = data.customfields;
        this.total = data.customfields ? data.customfields.length : 0;
      } else {
        this.$notify.error("error_loading_custom_fields_data");
      }
      this.isLoading = false;
    },

    reload() {
      this.getCustomfields();
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    onPageChange(page) {
      this.page = page;
      this.reload();
    },

    onSort(field, order) {
      this.orderField = field;
      this.orderDir = order;
      this.reload();
    },

    async removeCustomfield(field) {
      this.$dialog.confirm({
        title: this.$t("delete"),
        message: this.$t("delete_generic", [field.name]),
        confirmText: this.$t("delete"),
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          this.customFieldId = null

          this.isLoading = true;
          let url = "/api/v2/customfield/" + field.id + "/delete";
          const { data } = await axios.delete(url);

          if (data.success) {
            this.$toast.open({
              message: this.$t("success_deleting_generic"),
              type: "is-success",
              position: "is-top-right"
            });
            await this.sleep(1000);
            this.reload();
          } else {
            this.isLoading = false;
            // Error
            this.$toast.open({
              message: data.error || this.$t("error_saving"),
              type: "is-danger",
              position: "is-top-right"
            });
          }
        }
      });
    },

    openCustomfieldModal(dataField) {
      if(dataField == null) {
        dataField = {
          project_id: this.projectId,
          id: 0,
          code: "",
          name: "",
          type: "",
          order_column: 0,
          create_new: true,
        };
      }
      this.$refs.custom_field_modal.show(dataField);
    },

    onCloseClicked() {
        this.customFieldId = null;
        this.checkedRows = [];
    },

    async readcustomfield(params) {

      if(this.customFieldId){

        if( this.showPanel === 'assigned' )
          this.loadingAssigned = true;
        else
          this.loaded = true;

        const { data } = await axios.get(
          "/api/v2/customfield/" + this.customFieldId,
          { params: params }
        );

        if (data && data.success) {
          this.form = data.customfield;
        } else {
          this.$notify.error("error_loading_measurement_units_data");
        }

        if( this.showPanel === 'assigned' )
          this.loadingAssigned = false;
        else
          this.loaded = false;
      }

    },

    onRowClicked(field, access = true) {
      if (access) {
        this.customFieldId = field.id;
        this.showPanel = 'values';
        this.readcustomfield( { } );
      }
    },

    // value
    // redirige a pantalla edicion
    editValue(valueId) {
      this.valuesInEdition.push(valueId) // edicion inline
    },

    // guarda cambios de la tarea y la saca del modo edicion
    async sendValueData(valueId, taskKey) {

      var url = '/api/v2/customfield-value/' + valueId;

      // Enviamos el form
      const { data } = await axios.post(url, this.form.values[taskKey])
      if (data && data.success) {

        // la sacamos del modo edicion
        this.valuesInEdition.splice(this.valuesInEdition.indexOf(valueId),1)

        this.$notify.success('success_editing')

      } else if(data && data.msg){

        this.$notify.error('no_access_permissions')

      } else {
        this.$notify.error('error_saving')
      }
    },

    // crea nueva tarea en esta plantilla
    async saveValue() {
      if (this.newValue.code == '') {
        this.$notify.error(this.$t('empty_field_required', ['código']))
        return
      }

      if (this.newValue.name == '') {
        this.$notify.error(this.$t('empty_field_required', ['nombre']))
        return
      }

      const { data } = await axios.post("/api/v2/customfield/" + this.customFieldId + "/value", {
        code: this.newValue.code,
        name: this.newValue.name,
        element_id: this.customFieldId
      })

      if (data && data.success) {
        // reload
        this.readcustomfield()
        this.newValue = new Form({
          code: '',
          name: '',
        }),

        this.$notify.success('success_editing')

      } else if(data && data.msg) {
        this.$notify.error('no_access_permissions')
      } else {
        this.$notify.error('error_saving')
      }
    },

    // elimina el valor
    async deleteValue(valueId, valueName) {

      let self = this;
      this.$dialog.confirm({
        title: this.$t('delete'),
        message: this.$t('delete_generic', [valueName]),
        confirmText: this.$t('delete'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => {

          const { data } = await axios.post("/api/v2/customfield-values/" + valueId + "/delete", {})
          if (data && data.success) {

            // reload
            this.readcustomfield()
            this.$notify.success('success_deleting_generic')

          } else if(data && data.msg){

            this.$notify.error('no_access_permissions')

          } else {
            this.$toast.open({
              message: data.error || this.$t("error_saving"),
              type: "is-danger",
              position: "is-top-right"
            });

            // this.$notify.error('error_saving')
          }
        }
      })
    },

  }
};
</script>